import api from './api';

export const countriesAPI = {
  // Get all countries with pagination
  getCountries: async (params = {}) => {
    const { page = 1, limit = 10, search = '', isActive } = params;
    const response = await api.get('/countries', {
      params: { page, limit, search, isActive }
    });
    return response.data;
  },

  // Get all active countries for dropdowns
  getAllCountries: async () => {
    const response = await api.get('/countries/all');
    return response.data;
  },

  // Get country by ID
  getCountry: async (id) => {
    const response = await api.get(`/countries/${id}`);
    return response.data;
  },

  // Create new country
  createCountry: async (countryData) => {
    const response = await api.post('/countries', countryData);
    return response.data;
  },

  // Update country
  updateCountry: async (id, countryData) => {
    const response = await api.put(`/countries/${id}`, countryData);
    return response.data;
  },

  // Delete country
  deleteCountry: async (id) => {
    const response = await api.delete(`/countries/${id}`);
    return response.data;
  }
};

export const currenciesAPI = {
  // Get all currencies with pagination
  getCurrencies: async (params = {}) => {
    const { page = 1, limit = 10, search = '', isActive } = params;
    const response = await api.get('/currencies', {
      params: { page, limit, search, isActive }
    });
    return response.data;
  },

  // Get all active currencies for dropdowns
  getAllCurrencies: async () => {
    const response = await api.get('/currencies/all');
    return response.data;
  },

  // Get currency by ID
  getCurrency: async (id) => {
    const response = await api.get(`/currencies/${id}`);
    return response.data;
  },

  // Create new currency
  createCurrency: async (currencyData) => {
    const response = await api.post('/currencies', currencyData);
    return response.data;
  },

  // Update currency
  updateCurrency: async (id, currencyData) => {
    const response = await api.put(`/currencies/${id}`, currencyData);
    return response.data;
  },

  // Delete currency
  deleteCurrency: async (id) => {
    const response = await api.delete(`/currencies/${id}`);
    return response.data;
  }
};